module.exports = __webpack_public_path__ + "static/img/防跑车装置状态识别.afec9cc5.png";